import axios from 'axios'
import { CALCULAR_ACRESCIMO_PASSAGEM_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function calcularAcrescimoPassagem (valorTotal, percentualAcrescimo) {
  const url = `${URL}/passagem/valor/${valorTotal}/acrescimo/${percentualAcrescimo}`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => dispatch({ type: CALCULAR_ACRESCIMO_PASSAGEM_USUARIO, payload: response }))
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const valorCalculado = parseFloat((valorTotal * (1 + percentualAcrescimo / 100)).toFixed(2));
        return dispatch({ type: CALCULAR_ACRESCIMO_PASSAGEM_USUARIO, payload: { status: 200, data: valorCalculado } });
      }
      throw erro;
    });
}
